import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import classnames from "classnames";
import Image from "next/image";
import { useMatchMedia } from "@/hooks";
import styles from "@/styles/Channel.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ChannelHeroImage(_ref) {
  var _channel$heroImage, _channel$heroImage2;

  var channel = _ref.channel;
  if (!channel) return null;
  var largeSize = useMatchMedia([{
    query: "screen and (min-width: 640px)",
    value: true
  }], false); // pc 1600 320
  // mb 1280 600
  // media query 640で切り替え

  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.hero, _defineProperty({}, styles.large, largeSize)),
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.inner,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.pc,
        children: (channel === null || channel === void 0 ? void 0 : (_channel$heroImage = channel.heroImage) === null || _channel$heroImage === void 0 ? void 0 : _channel$heroImage.pc) && /*#__PURE__*/_jsx(Image, {
          src: channel.heroImage.pc,
          alt: channel.name,
          width: 1600,
          height: 320,
          layout: "responsive"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.mb,
        children: (channel === null || channel === void 0 ? void 0 : (_channel$heroImage2 = channel.heroImage) === null || _channel$heroImage2 === void 0 ? void 0 : _channel$heroImage2.mb) && /*#__PURE__*/_jsx(Image, {
          src: channel.heroImage.mb,
          alt: channel.name,
          width: 1280,
          height: 600,
          layout: "responsive"
        })
      })]
    })
  });
}